import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/generate-copies/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TitlebarFileMenuConfig, FileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { isBVisitC } from '@src/js/common/utils';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { POSITIONS } from '@tencent/txdocs-aid';
import { MenuKey } from '../../schema/menu-schema/common';
import { isCloudSlide } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';

@Controller({ menuItems: MENU_CONFIGS })
export class GenerateCopiesController {
    @Menu(ActionType.GENERATE_COPIES, 'onClick')
    @Menu(MenuKey.GENERATE_COPIES_HOR, 'onClick')
    public generateCopies(): void {
        const { produceBackupManager } =  this.getAppServices().viewableServiceLayer;
        produceBackupManager.promise().then((produceBackupManager) => {
            produceBackupManager.generateProduceBackup({ aidOptions: { aidPosition: POSITIONS.TOOLBAR } });
        });
    }

    // 右上角菜单 普通菜单项， 云文件需隐藏
    @Menu(ActionType.GENERATE_COPIES, 'shouldHide')
    public handleHide() {
        return this.shouldHide() || isCloudSlide();
    }

    // 右上角菜单 横向菜单项， 云文件显示
    @Menu(MenuKey.GENERATE_COPIES_HOR, 'shouldHide')
    public handleHideHorMenu() {
        return this.shouldHide() || !isCloudSlide();
    }

    @Menu(ActionType.GENERATE_COPIES, 'shouldDisabled')
    @Menu(MenuKey.GENERATE_COPIES_HOR, 'shouldDisabled')
    public handleDisabled() {
        // b端用户访问c端时, 禁用生成副本
        // 当前文档禁止生成副本, 禁用生成副本
        // 加密文件夹中禁用生成副本
        return isBVisitC() || !(SlideDataServices.PrivilegeManager()?.canGenerateCopies);
    }

    private shouldHide() {
        return !!(appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false)
        || !(appConfigInstance.getConfig(FileMenuConfig.clone as any) ?? true);
    }

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }
}
